export default __webpack_public_path__ + "static/media/navigation.e51ccc6d.jpg";